import { api } from './api';

export function getHubSummary() {
  return api.get('/api/community/hub-summary');
}

export function listCommunityEvents() {
  return api.get('/api/community/events');
}

export function createRecognition(body) {
  return api.post('/api/community/recognitions', body);
}
